import { render, staticRenderFns } from "./AddOfferItems.vue?vue&type=template&id=302c5674&scoped=true"
import script from "./AddOfferItems.vue?vue&type=script&lang=ts"
export * from "./AddOfferItems.vue?vue&type=script&lang=ts"
import style0 from "./AddOfferItems.vue?vue&type=style&index=0&id=302c5674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302c5674",
  null
  
)

export default component.exports